// extracted by mini-css-extract-plugin
export default {"tickCircleWrapper":"TickCircle-module--tick-circle-wrapper--ef1f5"};